import { Box, Heading, Stack, Text } from "@chakra-ui/react";
import React from "react";

import { Page } from "../components/custom";
import VirtualAccountsDashboard from "../modules/VirtualAccounts/VirtualAccounts/VirtualAccountsDashboard";

export default function VirtualAccountsPage() {
  return (
    <Page title="Virtual Accounts">
      <section>
        <Stack
          direction={{ base: "column", md: "row" }}
          justifyContent="space-between"
          alignItems="baseline"
        >
          <Box>
            <Heading
              as="h1"
              fontWeight={400}
              fontSize="1.5rem"
              lineHeight="133%"
              letterSpacing="-0.1px"
              mb={1}
              maxW="335px"
            >
              Virtual Accounts
            </Heading>
            <Text color="gray.300" maxW="335px">
              Find the Virtual Accounts on Bet9ja
            </Text>
          </Box>
        </Stack>
      </section>
      <Box mt={5}>
        <VirtualAccountsDashboard />
      </Box>
    </Page>
  );
}
